

































































































































































































import Vehicle from "@/data/models/Vehicle";
import { COLOR_DISABLED, COLOR_HEADER_BUTTON, COLOR_PRIMARY, COLOR_TABLE_HEADER, COLOR_TABLE_HEADER_DARK } from "@/utils/colors";
import { themed } from "@/utils/Theme";
import { Component, Ref, Vue, Watch } from "vue-property-decorator";
import router from "@/router/router";
import { GenericDeviceFilter, getGenericFilterName, matchesGenericDeviceFilter } from "@/data/models/DeviceFilter";
import { getNumber, setNumber } from "@/utils/SecureLocalStorage";
import { getActiveUser, getActiveUserId, getBranchesVisibleToActiveUser, getDefaultBranchFilterOfUser } from "@/data/repository/UserRepository";
import { UserModule } from "@/store/modules/UserModule";
import { ToolbarContentModule } from "@/store/modules/ToolbarContent";
import { findBranch, getBranchesOfClient, hasClientEnabledStrictBranchFilters } from "@/data/repository/ClientRepository";
import { BranchFilter } from "@/data/models/BranchFilter";
import { observeDeviceOverviews } from "@/data/repository/AllDevicesRepository";
import { DeviceOverview } from "@/data/models/DeviceOverview";
import ClientPanel, { ClientPanelExtended } from "@/data/models/ClientPanel";
import { observeClientPanels, updateClientPanelsBySerialNumber } from "@/data/repository/ClientPanelRepository";
import InfiniteLoading, { StateChanger } from "vue-infinite-loading";
import { filterRetainedDevices } from "@/utils/DeviceManagementUtils";
import { isClientPanel, isDeviceOverview, getCategoryIdFromSerialNumber, getTemplateIdFromSerialNumber, CATEGORY_HY_DRY_ID, CATEGORY_COM_BOX_ID } from '@/data/models/DeviceSettingsManager';
import { getBranchName } from "@/data/models/Branch";
import { getVehicleById, updateVehicleById } from "@/data/repository/VehicleRepository";
import VehicleDeviceItemComponent from "./VehicleDeviceItemComponent.vue";
import SearchForDeviceComponent from "../devices/SearchForDevice.vue";
import MenuIconWithSelectionListComponent from "../common/FilterMenu.vue";
import ConfirmationDialogComponent from "../common/ConfirmationDialog.vue";
import { firestore } from "firebase";
import { updateDevicesById } from "@/data/repository/GenericDeviceRepository";
import PickerDialogComponent from "../common/PickerDialog.vue";
import { ButtonState } from "../common/StateButton.vue";
import { DeviceCategoriesAndTemplatesModule } from "@/store/modules/DeviceCategoriesAndTemplatesModule";
import { defineCategoriesAndTemplatesClientAccess, manageAllDevicesClientAccess } from "@/permissions/ClientPermissions";
import { calculateBackgroundStyle, StorageKeyLastVisitedItemLevel } from "@/utils/Utils";

type FlatDevice = (DeviceOverview | ClientPanelExtended) & {
  __templateId: string;
  __categoryId: string;
};

enum VIEW {
  "DEVICES_OVERVIEW" = 1,
  "LOAD_DEVICES" = 2,
  "UNLOAD_DEVICES" = 3
}

@Component({
  name: "VehicleDevicesListComponent",
  components: {
    "vehicle-device-item": VehicleDeviceItemComponent,
    "infinite-loading": InfiniteLoading,
    "menu-icon": MenuIconWithSelectionListComponent,
    "search-for-device": SearchForDeviceComponent,
    "confirmation-dialog": ConfirmationDialogComponent,
    picker: PickerDialogComponent,
  },
})

export default class VehicleDevicesListComponent extends Vue {
  subscriptions: Array<() => void> = [];
  allFilters = Object.values(GenericDeviceFilter).filter(value => typeof value === 'number');

  componentActive = false;
  forceUpdateBackgroundColor = false;
  hasNoDevices = true;
  infiniteId = new Date();
  searchInfiniteId = new Date();
  isLoading = true;
  pageSize = 20;
  refreshTimer!: NodeJS.Timeout;
  timer: NodeJS.Timeout | null = null;
  refreshTrigger = 0;
  searchQuery: string | null = null;
  searchQueryKey = "VehicleDevicesSearchQuery";
  searchTimeout: NodeJS.Timeout | null = null;
  selectedBranchFilter = getDefaultBranchFilterOfUser();
  selectedDeviceFilter = GenericDeviceFilter.ALL_DEVICES;
  showNoDevicesMessage = false;
  sliceLength = this.pageSize;
  searchSliceLength = this.pageSize;

  isMovingDevices = false;
  isReadOnly = false;

  storageKeyVehicleDevicesFilter = "storageKeyVehicleDevicesFilter";
  storageKeyVehicleDevicesSliceLength = "storageKeyVehicleDevicesSliceLength";

  vehicleId = "";
  vehicle: Vehicle | null = null;
  branchId: string | null | undefined = null;
  initialBranchId: string | null | undefined = null;
  retrievedClientPanels: ClientPanelExtended[] = [];
  retrieveDeviceOverviews: DeviceOverview[] = [];

  selectedView = VIEW.DEVICES_OVERVIEW;
  selectedClientPanels: ClientPanelExtended[] = [];
  selectedDeviceOverviews: DeviceOverview[] = [];
  isAllSelected = false;

  expandedCategories: string[] = [];
  expandedTemplates: string[] = [];

  priorityIds = [CATEGORY_COM_BOX_ID, CATEGORY_HY_DRY_ID];

  devicesOverviewButtonText = this.$t("vehicles.devices.overview").toString();
  loadDevicesButtonText = this.$t("vehicles.devices.load").toString();
  unloadDevicesButtonText = this.$t("vehicles.devices.unload").toString();
  concludeButtonText = this.$t("common.finished").toString();
  abortButtonText = this.$t("common.abort").toString();
  concludeLoadingText = this.$t("vehicles.devices.concludeLoading").toString();

  showingSuccessSnackbar = false;
  successSnackbarText = "";

  showingErrorSnackbar = false;
  errorSnackbarText = "";

  snackbarTimeout = 5000;
  currentWidth = window.innerWidth;

  @Ref("confirmDialog")
  confirmationDialog!: ConfirmationDialogComponent;

  @Watch("hasNoDevices")
  onHasNoDevicesChanged() {
    this.processDevicesChange();
  }

  @Watch("branchId")
  onBranchFilterChanged() {
    if (!this.branchId) {
      return;
    }

    const branch = findBranch(this.branchId);

    if (branch) {
      this.selectedBranchFilter = new BranchFilter(
        hasClientEnabledStrictBranchFilters(),
        branch
      );

      this.resetDevices();
      this.updateCurrentLocationOfDevicesAndVehicle();
    }
  }

  @Watch("selectedDeviceFilter")
  onFilterChanged(newFilter: GenericDeviceFilter) {
    this.setToolbarTitle(newFilter);
    this.resetDevices();

    setNumber(this.storageKeyVehicleDevicesFilter, this.selectedDeviceFilter);
  }

  @Watch("isAllSelected")
  onIsAllSelectedChanged(newValue: boolean, oldValue: boolean) {
    if (newValue === oldValue) {
      return;
    }

    if (this.isAllSelected) {
      const clientPanels = this.devicesToDisplay.filter((device) => isClientPanel(device)) as ClientPanel[];
      const deviceOverviews = this.devicesToDisplay.filter((device) => isDeviceOverview(device)) as DeviceOverview[];

      this.selectedClientPanels = clientPanels;
      this.selectedDeviceOverviews = deviceOverviews;
    }
    else {
      this.resetSelectedDevices();
    }
  }

  get activeUser() {
    return getActiveUser() ?? UserModule.activeUser;
  }

  get colorPrimary() {
    return COLOR_PRIMARY;
  }

  get tableHeaderColor() {
    return themed(COLOR_TABLE_HEADER, COLOR_TABLE_HEADER_DARK);
  }

  get dividerStyle() {
    return this.currentWidth < 1047 ? { visibility: 'hidden' } : {};
  }

  get branchButtonState() {
    return this.isReadOnly
      ? ButtonState.DISABLED
      : ButtonState.RED;
  }

  get concludeUnloadingText() {
    return this.$t("vehicles.devices.concludeUnloading", [this.branchName]).toString()
  }

  get areSelectionActionsEnabled() {
    return (!this.isSelectionMode && this.devicesToDisplay.length > 0) ||
      (this.selectedClientPanels.length > 0 || this.selectedDeviceOverviews.length > 0);
  }

  get numberOfSelectedDevices() {
    return this.selectedClientPanels.length + this.selectedDeviceOverviews.length;
  }

  get headerDescription() {
    const numberOfDevices = this.isSelectionMode
      ? this.numberOfSelectedDevices
      : this.devicesInVehicle.length;

    const filtersName = this.isSelectionMode
      ? this.$tc("vehicles.devices.numberOfSelectedDevices", numberOfDevices).toString()
      : this.$tc("vehicles.devices.numberOfAvailableDevices", numberOfDevices).toString();

    return filtersName;
  }

  get flatFilteredDevices(): FlatDevice[] {
    const query = this.searchQuery?.trim().toLowerCase();
    if (!query) return [];

    const devices: FlatDevice[] = [];

    for (const [categoryId, templates] of Object.entries(this.devicesByCategoryAndTemplate)) {
      for (const [templateId, deviceList] of Object.entries(templates)) {
        for (const device of deviceList) {
          devices.push({
            ...device,
            __templateId: templateId,
            __categoryId: categoryId,
          });
        }
      }
    }

    return devices;
  }

  get groupedFlatDevices(): Record<string, FlatDevice[]> {
    const result: Record<string, FlatDevice[]> = {};
    const seenCategories = new Set<string>();

    for (const device of this.searchedDevicesToDisplay) {
      const categoryId = device.__categoryId;
      const templateId = device.__templateId;
      const key = `${categoryId}::${templateId}`;

      const attachCategoryId = !seenCategories.has(categoryId);
      if (attachCategoryId) {
        seenCategories.add(categoryId);
      }

      const newDevice = {
        ...device,
        __categoryId: attachCategoryId ? categoryId : "",
      };

      if (!result[key]) {
        result[key] = [];
      }

      result[key].push(newDevice);
    }

    this.$nextTick(() => {
      this.isLoading = false;
      this.showNoDevicesMessage = Object.keys(result).length === 0;
    });

    return result;
  }

  get isSelectionMode() {
    return this.selectedView !== VIEW.DEVICES_OVERVIEW;
  }

  get isIntermediate() {
    return this.numberOfSelectedDevices > 0 &&
      this.numberOfSelectedDevices !== this.devicesToDisplay.length;
  }

  get isUnloadingDevices() {
    return this.selectedView === VIEW.UNLOAD_DEVICES;
  }

  get isLoadingDevices() {
    return this.selectedView === VIEW.LOAD_DEVICES;
  }

  get deviceFilterIconRes() {
    return "mdi-filter-variant";
  }

  get leftButtonText() {
    const selectedView = this.selectedView;

    switch (selectedView) {
      case VIEW.DEVICES_OVERVIEW:
        return this.loadDevicesButtonText;

      default:
        return this.numberOfSelectedDevices === 0
          ? this.concludeButtonText
          : this.abortButtonText;
    }
  }

  get rightButtonText() {
    const selectedView = this.selectedView;

    switch (selectedView) {
      case VIEW.LOAD_DEVICES:
        return this.concludeLoadingText;
      case VIEW.UNLOAD_DEVICES:
        return this.concludeUnloadingText;

      default:
        return this.unloadDevicesButtonText;
    }
  }

  get noDevicesHintMessage() {
    if (this.searchQuery) {
      return this.$t("vehicles.devices.noMatchingDevicesFound").toString();
    }
    else {
      return this.$t("vehicles.devices.emptyDevicesHint").toString();
    }
  }

  get retainedDevices() {
    return filterRetainedDevices([
      ...this.retrievedClientPanels,
      ...this.retrieveDeviceOverviews
    ]);
  }

  get sortedAndFilteredDevices() {
    return this.filterDevices(
      this.devices
        .sort((a, b) => {
          const aIsClient = isClientPanel(a);
          const bIsClient = isClientPanel(b);

          // Place client panels first
          if (aIsClient && !bIsClient) return -1;
          if (!aIsClient && bIsClient) return 1;

          // Both are the same type – sort alphabetically
          const aKey = (a.inventoryNumber ?? a.serialNumber ?? "").toLowerCase();
          const bKey = (b.inventoryNumber ?? b.serialNumber ?? "").toLowerCase();

          return aKey.localeCompare(bKey);
        })
    );
  }

  get devices() {
    const canLoadGenericDevices = manageAllDevicesClientAccess();

    return this.retainedDevices
      .filter((device) => {
        const selectedView = this.selectedView;

        switch (selectedView) {
          case VIEW.LOAD_DEVICES:
            // Without "Alle Geräte verwalten" only HyDry devices can be loaded. Generic devices
            // already in the vehicle stay listed below, so they can still be unloaded.
            return !device.vehicleId && (canLoadGenericDevices || isClientPanel(device));

          default:
            // TODO: Update this and filter out the devices assigned to project.
            return device.vehicleId === this.vehicleId;
        }
      });
  }

  get devicesInVehicle() {
    return this.retainedDevices
      // TODO: Update this and filter out the devices assigned to project.
      .filter((device) => device.vehicleId === this.vehicleId);
  }

  get showInfiniteLoading() {
    return this.devicesToDisplay.length > 0;
  }

  get devicesToDisplay() {
    return this.sliceDevicesToDisplay(this.sliceLength);
  }

  get searchedDevicesToDisplay() {
    return this.flatFilteredDevices.slice(0, this.searchSliceLength);
  }

  get branchName() {
    const branchNumber = this.getBranchNumber(this.branchId);

    if (!branchNumber) {
      return "";
    }

    const branches = getBranchesOfClient();
    const deviceBranch = branches.find(branch => branchNumber.toString() === branch.branchNumber.toString());

    return deviceBranch?.name ?? "";
  }

  get isStructuredView() {
    return this.isLoadingDevices;
  }

  get deviceCategories() {
    const priorityIds = this.priorityIds;
    const deviceSettingsJson = this.deviceSettingsJson;

    return deviceSettingsJson
      ? [...deviceSettingsJson.deviceCategories].sort((a, b) => {
        if (priorityIds.includes(a.id) && priorityIds.includes(b.id)) {
          return priorityIds.indexOf(a.id) - priorityIds.indexOf(b.id);
        } else if (priorityIds.includes(a.id)) {
          return -1;
        } else if (priorityIds.includes(b.id)) {
          return 1;
        } else {
          return a.categoryName.localeCompare(b.categoryName);
        }
      })
      : [];
  }

  get devicesByCategoryAndTemplate() {
    const devices = this.sortedAndFilteredDevices;
    const result: Record<string, Record<string, (DeviceOverview | ClientPanelExtended)[]>> = {};

    // Get the preferred category order from deviceCategories
    const categoryPriority = this.deviceCategories.map(cat => cat.id);

    // Group devices by category and template
    for (const device of devices) {
      const categoryId = isClientPanel(device)
        ? getCategoryIdFromSerialNumber(device.serialNumber)
        : device.categoryId;
      const templateId = isClientPanel(device)
        ? getTemplateIdFromSerialNumber(device.serialNumber)
        : device.templateId;

      if (!result[categoryId]) {
        result[categoryId] = {};
      }
      if (!result[categoryId][templateId]) {
        result[categoryId][templateId] = [];
      }

      this.hasNoDevices = false;
      result[categoryId][templateId].push(device);
    }

    // Sort the result object using the categoryPriority order
    const sortedResult: typeof result = {};
    for (const categoryId of categoryPriority) {
      if (result[categoryId]) {
        sortedResult[categoryId] = result[categoryId];
      }
    }
    // Include any leftover categories not in the priority list
    for (const categoryId in result) {
      if (!sortedResult[categoryId]) {
        sortedResult[categoryId] = result[categoryId];
      }
    }
    return sortedResult;
  }

  get isAllowedToDefineOwnDeviceCategoriesAndTemplates() {
    return defineCategoriesAndTemplatesClientAccess();
  }

  get sharedDeviceSettingsJson() {
    return DeviceCategoriesAndTemplatesModule.sharedDeviceCategoriesAndTemplates;
  }

  get localDeviceSettingsJson() {
    return DeviceCategoriesAndTemplatesModule.localDeviceCategoriesAndTemplates;
  }

  get deviceSettingsJson() {
    return this.isAllowedToDefineOwnDeviceCategoriesAndTemplates
      ? this.localDeviceSettingsJson
      : this.sharedDeviceSettingsJson;
  }

  async created() {
    const rawVehicleId = router.currentRoute.query["vehicleId"];
    this.vehicleId = Array.isArray(rawVehicleId) ? rawVehicleId[0] ?? "" : rawVehicleId ?? "";

    if (!this.vehicleId) {
      router.back();
    }

    this.vehicle = await getVehicleById(this.vehicleId);

    if (!this.vehicle) {
      router.back();
    }

    this.branchId = this.getBranchId(this.vehicle?.branch);
    this.initialBranchId = this.branchId;

    const cachedDeviceFilter =
      getNumber(this.storageKeyVehicleDevicesFilter) ?? GenericDeviceFilter.ALL_DEVICES;

    if (cachedDeviceFilter != null && cachedDeviceFilter !== undefined) {
      this.selectedDeviceFilter = cachedDeviceFilter;
    }

    const cachedSliceLenth = getNumber(this.storageKeyVehicleDevicesSliceLength);
    if (cachedSliceLenth) {
      this.sliceLength = cachedSliceLenth;
      setNumber(this.storageKeyVehicleDevicesSliceLength);
    }

    setTimeout(() => {
      if (this.hasNoDevices) {
        this.isLoading = false;
        this.showNoDevicesMessage = true;
      }
    }, 800);

    this.setToolbarTitle(this.selectedDeviceFilter);
  }

  mounted() {
    const isReadOnly = router.currentRoute.query["isReadOnly"] as string;
    this.isReadOnly = isReadOnly === "true" ? true : false;

    window.addEventListener('resize', this.updateWidth);

    const cachedSearchedQuery = localStorage.getItem(this.searchQueryKey);

    if (cachedSearchedQuery) {
      localStorage.removeItem(this.searchQueryKey);

      this.searchQuery = cachedSearchedQuery;
    }

    this.subscriptions.push(observeDeviceOverviews(
      (deviceOverview: Array<DeviceOverview>) => {
        this.retrieveDeviceOverviews = deviceOverview;
      }
    ));
    this.subscriptions.push(observeClientPanels(
      (clientPanels: Array<ClientPanel>) => {
        this.retrievedClientPanels = clientPanels.map(panel => ({
          ...panel,
          id: panel.serialNumber,
        })) as ClientPanelExtended[];
      }
    ));

    this.startRefreshTimer();

    this.componentActive = true;
  }

  activated() {
    this.componentActive = true;
    this.setToolbarTitle(this.selectedDeviceFilter);
  }

  deactivated() {
    this.componentActive = false;
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.updateWidth);

    this.searchQuery = null;
    localStorage.removeItem(this.searchQueryKey);

    this.subscriptions.forEach((subscription) => subscription());
    clearInterval(this.refreshTimer);
  }

  updateWidth() {
    this.currentWidth = window.innerWidth;
  }

  isClientPanel(device: ClientPanelExtended | DeviceOverview) {
    return isClientPanel(device) ? true : false;
  }

  toggleCategory(categoryId: string) {
    const index = this.expandedCategories.indexOf(categoryId);
    if (index >= 0) {
      this.expandedCategories.splice(index, 1);
    } else {
      this.expandedCategories.push(categoryId);
    }
  }

  toggleTemplate(templateId: string) {
    const index = this.expandedTemplates.indexOf(templateId);
    if (index >= 0) {
      this.expandedTemplates.splice(index, 1);
    } else {
      this.expandedTemplates.push(templateId);
    }
  }

  getCategoryName(categoryId: string): string {
    const match = this.deviceSettingsJson?.deviceCategories?.find(cat => cat.id === categoryId);
    return match?.categoryName ?? categoryId;
  }

  getTemplateName(templateId: string): string {
    const allTemplates = this.deviceSettingsJson?.deviceCategories?.flatMap(cat => cat.deviceTemplates) || [];
    const match = allTemplates.find(t => t.id === templateId);
    return match?.deviceName ?? templateId;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getDeviceCountForCategory(templates: Record<string, any[]>): number {
    return Object.values(templates).reduce((sum, arr) => sum + arr.length, 0);
  }

  getBranchId(branchNumber: string | number | null | undefined) {
    if (!branchNumber) {
      return null;
    }

    const branches = getBranchesOfClient();
    const deviceBranch = branches.filter(branch => branchNumber.toString() === branch.branchNumber.toString());

    if (deviceBranch.length === 1) {
      return deviceBranch[0].id;
    }

    return null;
  }

  getBranchIdForDevice(device: ClientPanelExtended | DeviceOverview) {
    if (!this.isLoadingDevices) {
      return this.branchId;
    }

    return this.getBranchId(device.branch);
  }

  getBranchNumber(branchId: string | null | undefined) {
    if (!branchId) {
      return null;
    }

    const branches = getBranchesOfClient();
    const deviceBranch = branches.filter(branch => branchId === branch.id.toString());

    if (deviceBranch.length === 1) {
      return deviceBranch[0].branchNumber;
    }

    return null;
  }

  calculateBackgroundStyle(itemId = "") {
    return calculateBackgroundStyle(itemId, StorageKeyLastVisitedItemLevel.LEVEL_3);
  }

  get branchOptions() {
    return getBranchesVisibleToActiveUser().map((branch) => branch.id);
  }

  get branchFormatter() {
    return (branchId: string) => {
      return getBranchName(findBranch(branchId));
    };
  }

  getGenericFilterName(deviceFilter: GenericDeviceFilter) {
    return getGenericFilterName(this, deviceFilter);
  }

  getLeftButtonColor() {
    return COLOR_HEADER_BUTTON;
  }

  getRightButtonColor() {
    return (this.isSelectionMode && this.numberOfSelectedDevices === 0) ||
      (!this.isSelectionMode && this.devicesToDisplay.length === 0)
      ? COLOR_DISABLED
      : COLOR_HEADER_BUTTON;
  }

  setToolbarTitle(newFilter: GenericDeviceFilter) {
    const vehicleId = this.vehicle?.vehicleId ?? "-";
    const pageDescription = this.$t("vehicles.devices.title", [vehicleId]).toString();

    const toolbarTitle =
      this.$t("pages.vehicles").toString() +
      " > " +
      pageDescription;

    const devicesString = this.selectedDeviceFilter === GenericDeviceFilter.ALL_DEVICES
      ? `${toolbarTitle}`
      : `${toolbarTitle} (${this.getGenericFilterName(newFilter)})`

    ToolbarContentModule.setToolbarTitle(devicesString);
  }

  resetSelectedDevices() {
    this.selectedClientPanels = [];
    this.selectedDeviceOverviews = [];
    this.isAllSelected = false;
  }

  async onLeftButtonPressed() {
    if (this.isSelectionMode) {
      if (this.numberOfSelectedDevices !== 0) {
        const result = await this.confirmationDialog.show({
          title: this.$t("common.confirmationDialog.cancelTitle").toString(),
          message: this.$t("common.confirmationDialog.cancelMessage").toString(),
        });

        if (!result) {
          return;
        }
      }

      this.selectedView = VIEW.DEVICES_OVERVIEW;
      this.selectedDeviceFilter = GenericDeviceFilter.ALL_DEVICES;
    }
    else {
      this.selectedView = VIEW.LOAD_DEVICES;
      this.selectedDeviceFilter = GenericDeviceFilter.AVAILABLE;
    }

    this.resetSelectedDevices();
    this.resetDevices();
  }

  async onRightButtonPressed() {
    const vehicleId = this.isUnloadingDevices
      ? null
      : this.vehicleId;
    const branchNumber = this.getBranchNumber(this.branchId);
    const devices = this.vehicle?.devices ?? [];

    if (this.isSelectionMode) {
      if (this.isUnloadingDevices && branchNumber) {
        const devicesFromDifferentWarehouse = [
          ...this.selectedClientPanels,
          ...this.selectedDeviceOverviews,
        ].filter(device => {
          const deviceHome = device.homeLocation ?? device.branch;
          return deviceHome && deviceHome.toString() !== branchNumber.toString();
        });

        if (devicesFromDifferentWarehouse.length > 0) {
          const confirmed = await this.confirmationDialog.show({
            title: this.$t("vehicles.devices.crossWarehouseUnloadTitle").toString(),
            message: this.$t("vehicles.devices.crossWarehouseUnloadMessage").toString(),
          });

          if (!confirmed) {
            return;
          }
        }
      }

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const update: any = {
        vehicleId: vehicleId,
        deviceLastMoved: {
          recordedAt: firestore.Timestamp.now(),
          recordedByUserId: getActiveUserId()
        },
      };

      if (branchNumber) {
        update.branch = branchNumber.toString();
      }

      const updatedClientPanels = new Map<string, Partial<ClientPanel>>();
      const updatedOtherDevices = new Map<string, Partial<DeviceOverview>>();

      this.selectedClientPanels.forEach((clientPanel) => {
        const homeLocation = clientPanel.homeLocation ?? clientPanel.branch;

        updatedClientPanels.set(
          clientPanel.serialNumber,
          {
            ...update,
            homeLocation,
          }
        );

        if (this.isUnloadingDevices) {
          const index = devices.indexOf(clientPanel.serialNumber);
          if (index > -1) {
            devices.splice(index, 1);
          }
        }
        else if (!devices.includes(clientPanel.serialNumber)) {
          devices.push(clientPanel.serialNumber);
        }
      });

      this.selectedDeviceOverviews.forEach((deviceOverview) => {
        const homeLocation = deviceOverview.homeLocation ?? deviceOverview.branch;

        updatedOtherDevices.set(
          deviceOverview.id,
          {
            ...update,
            homeLocation,
          }
        );

        if (this.isUnloadingDevices) {
          const index = devices.indexOf(deviceOverview.id);
          if (index > -1) {
            devices.splice(index, 1);
          }
        }
        else if (!devices.includes(deviceOverview.id)) {
          devices.push(deviceOverview.id);
        }
      });

      this.isMovingDevices = true;
      const [isUpdateClientPanelsSuccessful, isUpdateOtherDevicesSuccessful, isUpdateVehicleSuccessful] = await Promise.all([
        updateClientPanelsBySerialNumber(updatedClientPanels),
        updateDevicesById(updatedOtherDevices),
        updateVehicleById(this.vehicleId, {
          devices
        }).then(() => true).catch(() => false)
      ]);

      if (
        (isUpdateClientPanelsSuccessful || this.selectedClientPanels.length === 0) &&
        (isUpdateOtherDevicesSuccessful || this.selectedDeviceOverviews.length === 0) &&
        isUpdateVehicleSuccessful
      ) {
        this.showingSuccessSnackbar = true;
        this.successSnackbarText = this.$tc(
          `vehicles.devices.${this.isUnloadingDevices ? "un" : ""}loadSuccessMessage`,
          this.numberOfSelectedDevices,
          this.isUnloadingDevices ? [this.branchName] : [this.vehicle?.vehicleId]
        ).toString();

        this.selectedView = VIEW.DEVICES_OVERVIEW;
        this.selectedDeviceFilter = GenericDeviceFilter.ALL_DEVICES;

        this.searchQuery = null;
        this.resetSelectedDevices();
      }
      else {
        this.showingErrorSnackbar = true;
        this.errorSnackbarText = this.$t(
          `vehicles.devices.${this.isUnloadingDevices ? "un" : ""}loadFailureMessage`,
          this.isUnloadingDevices ? [this.branchName] : [this.vehicle?.vehicleId]
        ).toString();
      }

      this.isMovingDevices = false;
    }
    else {
      this.selectedView = VIEW.UNLOAD_DEVICES;
      this.selectedDeviceFilter = GenericDeviceFilter.AVAILABLE;

      this.resetSelectedDevices();
    }
  }

  async updateCurrentLocationOfDevicesAndVehicle() {
    if (this.branchId === this.initialBranchId) {
      return;
    }

    /* if (this.devicesInVehicle.length === 0) {
      return;
    } */

    const branchNumber = this.getBranchNumber(this.branchId);

    if (!branchNumber || this.isMovingDevices) {
      return;
    }

    /* // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const update: any = {
      branch: branchNumber.toString()
    };

    this.isMovingDevices = true;

    const clientPanels = this.devicesInVehicle.filter((device) => isClientPanel(device)) as ClientPanel[];
    const deviceOverviews = this.devicesInVehicle.filter((device) => isDeviceOverview(device)) as DeviceOverview[];
    const numberOfSelectedDevices = clientPanels.length + deviceOverviews.length;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const updatedClientPanels = new Map<string, any>();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const updatedOtherDevices = new Map<string, any>();

    clientPanels.forEach((clientPanel) => {
      const homeLocation = clientPanel.homeLocation ?? clientPanel.branch;

      updatedClientPanels.set(
        clientPanel.serialNumber,
        {
          ...update,
          homeLocation,
        }
      );
    });

    deviceOverviews.forEach((deviceOverview) => {
      const homeLocation = deviceOverview.homeLocation ?? deviceOverview.branch;

      updatedOtherDevices.set(
        deviceOverview.id,
        {
          ...update,
          homeLocation,
        }
      );
    }); */

    await updateVehicleById(this.vehicleId, {
      branch: branchNumber
    });

    /* const [isUpdateClientPanelsSuccessful, isUpdateOtherDevicesSuccessful] = await Promise.all([
      updateClientPanelsBySerialNumber(updatedClientPanels),
      updateDevicesById(updatedOtherDevices),
      updateVehicleById(this.vehicleId, {
        branch: branchNumber
      })
    ]);

    if (
      (isUpdateClientPanelsSuccessful || clientPanels.length === 0) && 
      isUpdateOtherDevicesSuccessful || deviceOverviews.length === 0
    ) {
      this.showingSuccessSnackbar = true;
      this.successSnackbarText = this.$tc(
          `vehicles.devices.locationUpdateSuccessMessage`,
          numberOfSelectedDevices
        ).toString();

      this.initialBranchId = this.branchId;
      this.resetSelectedDevices();
    }
    else {
      this.showingErrorSnackbar = true;
      this.errorSnackbarText = this.$tc(
          `vehicles.devices.locationUpdateFailureMessage`,
          numberOfSelectedDevices
        ).toString();
    }

    this.isMovingDevices = false; */
  }

  onSelectDevice(device: DeviceOverview | ClientPanelExtended) {
    if (this.isReadOnly) {
      return;
    }

    const isHyDryDevice = isClientPanel(device);

    if (this.isSelectionMode) {
      if (isHyDryDevice) {
        const clientPanel = device as ClientPanel;
        const index = this.selectedClientPanels.indexOf(clientPanel, 0);

        if (index > -1) {
          this.selectedClientPanels.splice(index, 1);
        }
        else {
          this.selectedClientPanels.push(clientPanel);
        }
      }
      else {
        const deviceOverview = device as DeviceOverview;
        const index = this.selectedDeviceOverviews.indexOf(deviceOverview, 0);

        if (index > -1) {
          this.selectedDeviceOverviews.splice(index, 1);
        }
        else {
          this.selectedDeviceOverviews.push(deviceOverview);
        }
      }

      if (this.numberOfSelectedDevices === this.devicesToDisplay.length) {
        this.isAllSelected = true;
      }
      else if (this.numberOfSelectedDevices === 0) {
        this.isAllSelected = false;
      }

    }
    else {
      this.forceUpdateBackgroundColor = !this.forceUpdateBackgroundColor;
    }
  }

  isDeviceSelected(device: DeviceOverview | ClientPanelExtended) {
    const isHyDryDevice = isClientPanel(device);

    return isHyDryDevice
      ? this.selectedClientPanels.includes(device as ClientPanelExtended)
      : this.selectedDeviceOverviews.includes(device as DeviceOverview);
  }

  filterDevices(devices: (DeviceOverview | ClientPanelExtended)[]) {
    const filter = this.selectedDeviceFilter;
    const branchFilter = this.selectedBranchFilter;
    const searchQuery = this.searchQuery?.toUpperCase();

    const result = devices.filter((device: DeviceOverview | ClientPanelExtended) =>
      (
        !this.isLoadingDevices ||
        branchFilter.doesMatchGenericDevice(device, false)
      ) &&
      matchesGenericDeviceFilter(
        filter,
        device
      )
    );

    if (searchQuery) {
      const searchQueryLowerCase = searchQuery.toLowerCase();

      const searchedDevices = result.filter(
        (device: DeviceOverview | ClientPanelExtended) => {
          const doesSerialNumberMatch = (device.serialNumber ?? "")
            .toLowerCase()
            .includes(searchQueryLowerCase);
          const doesInventoryNumberMatch = (device.inventoryNumber ?? "")
            .toLowerCase()
            .includes(searchQueryLowerCase);
          const doesQrCodeMatch = (device.qrCode ?? "")
            .toLowerCase()
            .includes(searchQueryLowerCase);

          return doesSerialNumberMatch ||
            doesInventoryNumberMatch ||
            doesQrCodeMatch;
        }
      );

      return searchedDevices;
    }

    return result;
  }

  resetDevices() {
    this.hasNoDevices = true;
    this.showNoDevicesMessage = false;
    this.sliceLength = this.pageSize;
    this.infiniteId = new Date();
    this.searchInfiniteId = new Date();
    this.processDevicesChange();
  }

  sliceDevicesToDisplay(length: number) {
    const devices = this.sortedAndFilteredDevices;
    this.hasNoDevices = devices.length === 0;

    const slicedDevices = devices.slice(0, length);

    return slicedDevices;
  }

  startRefreshTimer() {
    this.refreshTimer = setInterval(() => {
      this.refreshTrigger++;
    }, 60 * 1000);
  }

  async infiniteHandler(data: StateChanger) {
    const nextSliceLength = this.sliceLength + this.pageSize;
    const nextSlice = this.sliceDevicesToDisplay(nextSliceLength);

    this.sliceLength = nextSliceLength;

    if (nextSliceLength > nextSlice.length) {
      data.complete();
    } else {
      data.loaded();
    }
  }

  async searchInfiniteHandler(data: StateChanger) {
    const nextSliceLength = this.searchSliceLength + this.pageSize;
    this.searchSliceLength = nextSliceLength;

    if (nextSliceLength >= this.flatFilteredDevices.length) {
      data.complete();
    } else {
      data.loaded();
    }
  }

  processDevicesChange() {
    if (this.hasNoDevices) {
      if (!this.isLoading) {
        this.isLoading = true;
        this.timer = setTimeout(() => {
          this.isLoading = false;
          this.showNoDevicesMessage = true;
        }, 1000);
      }
    } else {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.isLoading = false;
      this.showNoDevicesMessage = false;
    }
  }

  processSearchQuery(newQuery: string) {
    this.searchQuery = newQuery;
    this.searchSliceLength = this.pageSize;
    this.resetDevices();
  }

  clearSearchQuery() {
    this.searchQuery = null;
    this.searchSliceLength = this.pageSize;
    this.resetDevices();
  }

  debounceSearch(newQuery: string) {
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }

    if (newQuery === "") {
      this.clearSearchQuery();
      return;
    }

    this.searchTimeout = setTimeout(() => {
      this.processSearchQuery(newQuery);
    }, 400);
  }
}
